import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAllBooking,
  Status,
} from "../../../../features/admin/cab_booking/all_booking/slice";
import { useLocation } from "react-router-dom";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.cab_booking.all_cab_booking);

  console.log(country, "countryyyyyyyyyyyyyyyyy");

  const [first_name, setName] = useState("");
  const [driverName, setDriverName] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [email, setemail] = useState("");
  const [contact_no, setcontact_no] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

   const query = new URLSearchParams(useLocation().search);
  
  const [bookingID, setBookingId] = useState(query.get("booking_id"));

  

  useEffect(() => {
    fetch();
  }, [bookingID]);

  useEffect(() => {
    fetch();
  }, [first_name, email, contact_no, from, to, driverName, bookingType]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAllBooking({
        first_name: first_name,
        driverName,
        bookingType,
        email,
        contact_no,
        bookingID,
        from,
        to,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  // const toggleStatus = async (id) => {
  //   try {
  //     await dispatch(Status(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  return {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    setDriverName,
    driverName,
    setBookingType,
    bookingType,
    setBookingId,
    // deleteData,
    // toggleStatus,
  };
};
